import { Link } from '@tanstack/react-router';

interface BrandLinkProps {
  className?: string;
}

/**
 * Site brand link. Always navigates to '/', which the root route's
 * beforeLoad (apps/www/app/routes/index.tsx) redirects to /dashboard
 * for authenticated users. This delegates auth-aware routing to the
 * existing server-side guard — no client session check required.
 */
export function BrandLink({ className }: BrandLinkProps) {
  return (
    <Link
      to="/"
      aria-label="NilBoard home"
      className={`flex items-center shrink-0 min-h-[44px] ${className ?? ''}`}
    >
      <img
        src="/logo-wordmark.svg"
        alt="NilBoard"
        className="h-12 sm:h-14 w-auto"
        width={200}
        height={90}
      />
    </Link>
  );
}
